// Pop up when the winner is selected
import { useEffect, useState } from 'react';
import '../styles/WinnerPopup.css';

type Props = {
  open: boolean;
  winner: string;
  onClose: () => void;
};

export default function WinnerPopup({ open, winner, onClose }: Props) {
  const [visible, setVisible] = useState(false);
  const [animationClass, setAnimationClass] = useState('');
  
  useEffect(() => {
    if (open) {
      setVisible(true);
      setTimeout(() => setAnimationClass('popup-enter'), 50);
    } else {
      setAnimationClass('popup-exit');
      const timer = setTimeout(() => {
        setVisible(false);
      }, 500); // Match this with animation duration
      return () => clearTimeout(timer);
    }
  }, [open]);
  
  if (!visible) return null;
  
  return (
    <div className={`winner-popup-overlay ${animationClass}`}>
      <div className="winner-popup-content">
        <div className="winner-crown"></div>
        <h2>We Have a Winner!</h2>
        <div className="winner-name">{winner}</div>
        <div className="winner-celebration">
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
        </div>
        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
